import ApiService from '@shared/services/api.service';

const ActivityLogService = {
  fetchList: (page, itemsPerPage, querySearch, fromDate, toDate) => {
    console.log(["fetchList", querySearch, fromDate, toDate]);
    if (fromDate && toDate) {
      return ApiService.get(`/user/activity_log?page=${page}&items_per_page=${itemsPerPage}&q=${querySearch}&start_date=${fromDate}&end_date=${toDate}`);
    } else {
      return ApiService.get(`/user/activity_log?page=${page}&items_per_page=${itemsPerPage}&q=${querySearch}`);
    }
  },
  fetchUrlOfFileToDownload: (fromDate, toDate, format) => ApiService.post(`/user/activity_log/get_download_url`, {
    "start_date": fromDate,
    "end_date": toDate,
    "format": format
  }),
  fetchAllowedPeriod: () => {
    return ApiService.get(`/user/activity_log/get_allowed_period`);
  }
};

export default ActivityLogService;
